import { render } from "./ClientProposal.vue?vue&type=template&id=d8d7208c&scoped=true"
import script from "./ClientProposal.vue?vue&type=script&lang=js"
export * from "./ClientProposal.vue?vue&type=script&lang=js"

import "./ClientProposal.vue?vue&type=style&index=0&id=d8d7208c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d7208c"]])

export default __exports__